var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 45,
  viewBox: "13.875 14.145 17.003 17.003",
  fill: "#0a1e2d",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m30.139 14.145.739.739-16.264 16.263-.738-.738z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m30.878 30.41-.74.738-16.263-16.263.74-.74z"
})));
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMzQ2NWYzNzFiNmJjNzI2YWZkZWI4MTFmNDI4YzllODAuc3ZnIjs=";